/**
 * Formats a camelCase string into a human-readable label
 * @param {string} key - The camelCase string to format
 * @returns {string} The formatted string
 * @example
 * formatLabel('firstName') // returns 'First Name'
 * formatLabel('dateOfBirth') // returns 'Date Of Birth'
 */
export const formatLabel = (key) => {
    if (!key) return '';

    return key
        .replace(/([A-Z])/g, ' $1')  // Insert space before capital letters
        .replace(/^./, str => str.toUpperCase())  // Capitalize first letter
        .trim();  // Remove extra spaces
};
